import React from 'react';
import { useTranslation } from 'react-i18next';
import { View, Select } from '@smarterservices/smarter-ui';
import useTranslations from '../hooks/useTranslations';

import { LanguageSwitcherProps } from '../types';

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslations();

  // Handle language change for InstructureUI Select
  // We need to use any here because the InstructureUI Select component's onChange event type
  // is complex and doesn't match a standard event pattern
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const changeLanguage = (event: any) => {
    if (event && event.target && event.target.value) {
      i18n.changeLanguage(event.target.value);
    }
  };

  return (
    <View as="div" margin="0 small 0 0" className={className}>
      <Select
        renderLabel={t('language.select', 'Select Language')}
        value={i18n.language}
        onChange={changeLanguage}
        width="10rem"
      >
        <Select.Option id="en" value="en">
          {t('language.en', 'English')}
        </Select.Option>
        <Select.Option id="es" value="es">
          {t('language.es', 'Spanish')}
        </Select.Option>
      </Select>
    </View>
  );
};

export default LanguageSwitcher;
